import { render, staticRenderFns } from "./CarLoan.vue?vue&type=template&id=64728323&scoped=true&"
import script from "./CarLoan.vue?vue&type=script&lang=js&"
export * from "./CarLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64728323",
  null
  
)

export default component.exports